<template>
  <div>
    <SignUpMembership></SignUpMembership>
  </div>
</template>

<script>
import SignUpMembership from "@/components/shoplus_service/partners/SignUpMembership.vue";

export default {
  components: {
    SignUpMembership,
  },
};
</script>
